import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "public-classes-and-enums"
    }}>{`Public classes and enums`}</h1>
    <p>{`This documents lists details about the public classes and enums available in Messaging extension.`}</p>
    <h2 {...{
      "id": "push-notification"
    }}>{`Push notification`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./messaging-push-payload.md"
        }}>{`Class - MessagingPushPayload`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./push-tracking-status.md"
        }}>{`Enum - PushTrackingStatus`}</a></li>
    </ul>
    <h2 {...{
      "id": "in-app-message"
    }}>{`In-app message`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./message.md"
        }}>{`Class - Message`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./messaging-edge-event-type.md"
        }}>{`Enum - MessagingEdgeEventType`}</a></li>
    </ul>
    <h2 {...{
      "id": "proposition-based-messagingbr--code-based-experiences--content-cards"
    }}>{`Proposition-based messaging`}<br />{` `}{`(`}{`Code-based experiences & Content Cards)`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./content-card.md"
        }}>{`Class - ContentCard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./proposition.md"
        }}>{`Class - Proposition`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./proposition-item.md"
        }}>{`Class - PropositionItem`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./surface.md"
        }}>{`Class - Surface`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./content-type.md"
        }}>{`Enum - ContentType`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./messaging-edge-event-type.md"
        }}>{`Enum - MessagingEdgeEventType`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./content-card-schema-data.md"
        }}>{`Schema Class - ContentCardSchemaData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./html-content-schema-data.md"
        }}>{`Schema Class - HtmlContentSchemaData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./inapp-schema-data.md"
        }}>{`Schema Class - InAppSchemaData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./json-content-schema-data.md"
        }}>{`Schema Class - JsonContentSchemaData`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      